// Authentication utility functions

const TOKEN_KEY = 'accessToken';
const ROLE_KEY = 'userRole';
const HOSPITAL_ID_KEY = 'hospitalId';
const CLINIC_ID_KEY = 'clinicId';
const USER_ID_KEY = 'userId';

/**
 * Save authentication data to localStorage
 */
export const saveAuth = (token, role, hospitalId, clinicId, userId) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(ROLE_KEY, role);
  localStorage.setItem(HOSPITAL_ID_KEY, hospitalId);
  localStorage.setItem(CLINIC_ID_KEY, clinicId);
  if (userId) {
    localStorage.setItem(USER_ID_KEY, userId);
  }
  
  console.log('✅ Auth saved to localStorage');
};

/**
 * Get authentication token
 */
export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Get user role
 */
export const getRole = () => {
  return localStorage.getItem(ROLE_KEY);
};

/**
 * Get hospital ID
 */
export const getHospitalId = () => {
  return localStorage.getItem(HOSPITAL_ID_KEY);
};

/**
 * Get clinic ID
 */
export const getClinicId = () => {
  return localStorage.getItem(CLINIC_ID_KEY);
};

/**
 * Get user ID
 */
export const getUserId = () => {
  return localStorage.getItem(USER_ID_KEY);
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = () => {
  const token = getToken();
  const role = getRole();
  
  // Check if both token and role exist (basic validation)
  // If either is missing, the session is incomplete/invalid
  if (!token || !role) {
    // Clear any partial auth data
    if (token || role) {
      clearAuth();
    }
    return false;
  }
  
  return true;
};

/**
 * Clear all authentication data
 */
export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(HOSPITAL_ID_KEY);
  localStorage.removeItem(CLINIC_ID_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem('selectedHospitalId');
  localStorage.removeItem('selectedHospitalName');
  
  console.log('✅ Auth cleared');
};

/**
 * Logout user
 */
export const logout = () => {
  clearAuth();
  window.location.href = '/?logout=true';
};
